import { render } from "./page-donate.vue?vue&type=template&id=b45e733c&scoped=true"
import script from "./page-donate.vue?vue&type=script&lang=js"
export * from "./page-donate.vue?vue&type=script&lang=js"

import "./page-donate.vue?vue&type=style&index=0&id=b45e733c&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-b45e733c"

export default script